import { useCallback as t } from "react";
import { isEmpty as a } from "../utils/object.utils.js";
const n = (r, e) => t((s) => {
  if (a(e))
    return 0;
  const o = e < r ? r : e;
  return o ? o / 100 * s : 0;
}, [r, e]);
export {
  n as usePercentageValueInPixels
};
//# sourceMappingURL=BironTable.utils.js.map
